import axios from 'axios';

let cancelRequest;

const showPensionIncome = async (app, date) => {
  const year = date.split('-')[2] || '';
  const moment = await import('moment');

  if (cancelRequest) {
    cancelRequest();
    cancelRequest = null;
  }

  if (year.length < 4 || !moment.default(date, 'DD-MM-YYYY').isValid()) {
    return false; // date is not valid
  }

  const abortController = new AbortController();
  cancelRequest = () => abortController.abort();
  return axios({
    method: 'post',
    url: `/${app}/calculate/verify-aow`,
    data: { date_of_birth: date },
    signal: abortController.signal,
  }).catch(err => console.error(err));
};

export default showPensionIncome;
